<template>
  <div class="layout">
    <div class="head">
      <slot name="head"></slot>
    </div>
    <div class="main">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.layout {
  @apply bg-white;
  color: var(--resume-font-color);
  font-family: var(--resume-font-family);
  padding: var(--resume-margin);
  line-height: var(--resume-line-height);
  :deep(h1),
  :deep(h2),
  :deep(h3) {
    @apply font-bold;
    color: var(--resume-primary-color);
    font-family: var(--resume-font-family);
  }
  .sidebar,
  .main,
  .head {
    grid-area: sidebar;
    @apply bg-transparent;
  }
  .head {
    @apply pb-0;
  }
  :deep(.header),
  :deep(.education),
  :deep(.work),
  :deep(.skills) {
    @apply pb-4 border-b border-black;
  }
  :deep(.head) {
    .summary::before {
      @apply font-bold text-lg inline-block mb-2;
      color: var(--resume-primary-color);
      font-family: var(--resume-font-family);
      content: 'Career Profile';
    }
  }
  :deep(.contact) {
    @apply !flex-col-reverse;
    .email-website-container,
    .phone-location-container,
    .internet-profiles-container {
      @apply flex-row gap-2 justify-end;
    }
  }
  .sidebar,
  .main {
    @apply pt-2-em;
  }
  .sidebar {
    background-color: var(--resume-background-color);
  }
}
</style>
